import { render, staticRenderFns } from "./editMenuBtn.vue?vue&type=template&id=0f16d644"
import script from "./editMenuBtn.vue?vue&type=script&lang=js"
export * from "./editMenuBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports